

















































import { Component, Vue } from 'vue-property-decorator'
import { PatientPostResponse } from '@/api/user/types'
import VueQrCode from 'vue-weblineindia-qrcode'
import { Route } from 'vue-router'

@Component({
  components: {
    VueQrCode
  }
})
export default class ManagePatientAddComplete extends Vue {
  readonly QR_SIZE = 200

  emailSendErrorMessage = ''

  createdPatient = {
    ...(this.$store.getters['user/sessionData'](
      'createdPatient'
    ) as PatientPostResponse)
  }

  created() {
    if (!this.createdPatient) {
      console.error('Invalid session')
      this.$router.push({ name: 'Home' })
      return
    }
  }

  handleClickCopy() {
    const range = document.createRange()
    const target = this.$refs.clipboadTarget as HTMLLinkElement
    const selection = window.getSelection() as Selection

    range.selectNodeContents(target)

    selection.removeAllRanges()
    selection.addRange(range)

    document.execCommand('copy')
    selection.removeAllRanges()
    this.$store.dispatch('alert/showMessages', ['コピーしました'])
  }

  async handleClickResend() {
    this.emailSendErrorMessage = ''
    try {
      const patientId = this.createdPatient.id
      await this.$api.user.sendMailToPatient({ patientId })
      this.$store.dispatch('alert/showMessages', ['メールを送信しました'])
    } catch (error) {
      this.emailSendErrorMessage =
        '送信に失敗しました。しばらくたってからもう一度お試し下さい。'
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: (allow?: boolean) => void) {
    this.$store.commit('user/deleteSessionData', 'createdPatient')
    next()
  }
}
